
// Header

(function () {

	var header = {

		checkScroll: function (e) {

			if ( !this.bottom ) return

			var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			this.bottom.classList.toggle( 'header__bottom_fixed', scrollTop >= this.offset );

		},

		checkResize: function (e) {

			if ( !this.bottom || !this.top ) return

			var width = Math.min( window.innerWidth, document.documentElement.clientWidth );

			this.el.style.height = width > 990 ? ( this.top.clientHeight + this.bottom.clientHeight ) + 'px' : null;

			this.offset = this.top.clientHeight;

		},

		init: function () {

			this.el = document.querySelector( '.header' );

			if ( !this.el ) return

			this.top = this.el.querySelector( '.header__top' );
			this.bottom = this.el.querySelector( '.header__bottom' );

			window.addEventListener( 'resize', this.checkResize.bind( this ) );
			window.addEventListener( 'scroll', this.checkScroll.bind( this ) );
			
			this.checkResize();
			this.checkScroll();

			return this

		}

	}

	return header.init();

})();
